import { Typography, TextField } from '@mui/material'
import cx from 'classnames'
import styles from './AddEmailForm.module.scss'
import { makeStyles } from '@material-ui/core/styles'
import colors from 'styles/_variables.module.scss'
import CircularAddButton from 'common/components/CircularAddButton/CircularAddButton'
import { EMAIL_REGEX } from 'utils/validation'

// The design draws the + at the same height as the field beside it
const ADD_BUTTON_SIZE = 42

const useStyles = makeStyles(() => ({
  input: {
    [`& fieldset`]: {
      borderRadius: 30,
      borderColor: colors.colorLightGray
    },
    '& label': {
      color: colors.colorLightGray
    },
    '& label.Mui-focused': {
      color: colors.colorPrimary
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'grey'
    },
    '& .MuiInputBase-inputMultiline': {
      padding: '12px'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: colors.colorLightGray
      },
      '&:hover fieldset': {
        borderColor: colors.colorLightGray
      },
      '&.Mui-focused fieldset': {
        borderColor: colors.colorPrimary
      }
    }
  }
}))

const AddEmailForm = ({
  title,
  setError,
  clearErrors,
  register,
  errors,
  addButtonLabel,
  handleAddClick,
  isAdding,
  translate,
  getValues,
  watch
}) => {
  const classes = useStyles()

  const handleEmailChange = event => {
    if (event.target.value !== '') {
      clearErrors('addressEmail')
      clearErrors('userSelfAssign')
    } else {
      setError('addressEmail', { shouldFocus: 'addressEmail' })
    }
  }

  return (
    <>
      <Typography className={styles.subTitle}>{title}</Typography>

      <div className={styles.email}>
        <TextField
          variant='outlined'
          onChange={handleEmailChange}
          label={translate('newEmail')}
          id='addressEmail'
          name='addressEmail'
          error={errors?.addressEmail || errors?.userSelfAssign}
          inputRef={register({ required: true })}
          className={cx(styles.emailInput, classes.input, {
            [styles.hasError]: errors?.addressEmail || errors?.userSelfAssign
          })}
          value={getValues('addressEmail') || ''}
        />
        <CircularAddButton
          ariaLabel={addButtonLabel}
          className={styles.addButton}
          disabled={!EMAIL_REGEX.test((watch('addressEmail') || '').trim().toLowerCase())}
          isLoading={isAdding}
          onClick={handleAddClick}
          size={ADD_BUTTON_SIZE}
        />
      </div>

      {errors?.addressEmail && (
        <div className={styles.error}>
          <small>{translate('validation.inValidEmail')}</small>
        </div>
      )}
      {errors?.userSelfAssign && (
        <div className={styles.error}>
          <small>{translate('validation.userSelfAssign')}</small>
        </div>
      )}
    </>
  )
}

export default AddEmailForm
